import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Datepicker from "react-tailwindcss-datepicker";
import { PiSpeakerHigh,PiSpeakerSlash } from "react-icons/pi";

import bgImage from "../assets/translatebg.jpg";
import { MovingBorderButton } from "./Button";
import axios from "axios";
import LoadingScreen from "./LoadingScreen";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { useSelector } from "react-redux";
import Avatar from "./Avatar";


const Itinerary = () => {
  const [selectedCity, setSelectedCity] = useState("");
  const [loading, setLoading] = useState(false);
  const [itinerary, setItinerary] = useState(null);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isDatepickerOpen, setIsDatepickerOpen] = useState(false);
  const [speak , setSpeak] = useState(true);
  const [numberOfPeople, setNumberOfPeople] = useState(1);
  const [budget, setBudget] = useState(5000);
  const [isItineraryGenerated, setIsItineraryGenerated] = useState(false);
  const dropdownRef = useRef(null);

  const navigate = useNavigate();
  const {user} = useSelector((state)=>state.auth)
  const cities = ["Goa", "Manali", "Chennai", "Kolkata", "Bhagalpur"];

  const [value, setValue] = useState({
    startDate: new Date(),
    endDate: new Date().setMonth(11),
  });

  const handleValueChange = (newValue) => {
    setValue((prevValue) => {
      return newValue;
    });
  };

  useEffect(() => {
    setValue(value)
  }, [value]);
  const handleCitySelect = (city) => {
    setSelectedCity(city);
    setIsDropdownOpen(false);
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsDropdownOpen(false);
    }
  };

  const handleIncrementPeople = () => {
    setNumberOfPeople((prev) => prev + 1);
  };

  const handleDecrementPeople = () => {
    setNumberOfPeople((prev) => (prev > 1 ? prev - 1 : 1));
  };

  const handleBudgetChange = (e) => {
    setBudget(Number(e.target.value));
  };



  const handleGenerateItinerary = async () => {
    setLoading(true);
    try {
      const input = `Give itinerary of ${selectedCity} for ${numberOfPeople} person from ${value.startDate} to ${value.endDate} and budget is ₹${budget}`;
      const response = await axios({
        url: "https://generativelanguage.googleapis.com/v1beta/models/gemini-2.5-flash:generateContent",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-goog-api-key": "AIzaSyD3yV_YREeaPTHd-krkWY-Vz6c87Gnb7EQ", // move API key to header
      },
        data: {
          contents: [{ parts: [{ text: input }] }],
        },
      });
      const text = response.data.candidates[0].content.parts[0].text;
      let filterText = text.replace(/##/g, '')
      let responseArray = filterText.split("**");
      let newResponse = "";
      for (let i = 0; i < responseArray.length; i++) {
        if (i === 0 || i % 2 !== 1) {
          newResponse += responseArray[i];
        } else {
          newResponse += "<b>" + responseArray[i] + "</b>";
        }
      }
      let newResponse2 = newResponse.split("*").join("<b>•</b>");
      let newResponse3 = newResponse2
        .split("\n")
        .map((line, index, lines) => {
          if (line.includes("•") && index < lines.length - 1) {
            return line + "<br>" + lines[index + 1];
          }
          return line;
        })
        .filter((line, index, lines) => !lines[index - 1]?.includes("•"))
        .join("<br>");
      setItinerary(newResponse3);
      setIsItineraryGenerated(true);
    } catch (error) {
      console.error("Error generating itinerary:", error);
    }
    setLoading(false);
  };


  const handleDownloadPdf = async () => {
    try {
      // Create an isolated wrapper for the content
      const wrapper = document.createElement('div');
      wrapper.style.fontSize = '28px'; // Increase font size here
      wrapper.style.lineHeight = '1.6'; // Adjust line height for better readability
      wrapper.innerHTML = itinerary;
  
      // Create a temporary container to hold the content
      const tempContainer = document.createElement('div');
      tempContainer.style.position = 'absolute';
      tempContainer.style.top = '-9999px';
      tempContainer.style.left = '-9999px';
      tempContainer.appendChild(wrapper);
      document.body.appendChild(tempContainer);
  
      const pdf = new jsPDF('p', 'mm', 'a4');
  
      const pdfPageHeight = pdf.internal.pageSize.getHeight();
      const pdfPageWidth = pdf.internal.pageSize.getWidth();
  
      // Use html2canvas to convert the HTML content to a canvas
      const canvas = await html2canvas(wrapper, {
        scale: 2,
        useCORS: true, // Enable CORS if you are loading images from another domain
        allowTaint: true, // Allow cross-origin images to be used in the canvas
      });
  
      // Remove the temporary container after rendering
      document.body.removeChild(tempContainer);
  
      // Split the canvas into multiple pages
      const canvasHeight = canvas.height;
      let y = 0;
  
      while (y < canvasHeight) {
        const canvasPage = document.createElement('canvas');
        canvasPage.width = canvas.width;
        canvasPage.height = Math.min(pdfPageHeight * (canvas.width / pdfPageWidth), canvas.height - y);
  
        const ctx = canvasPage.getContext('2d');
        ctx.drawImage(
          canvas,
          0, y, canvas.width, canvasPage.height,
          0, 0, canvasPage.width, canvasPage.height
        );
  
        const imgData = canvasPage.toDataURL('image/png');
        if (y > 0) {
          pdf.addPage();
        }
        pdf.addImage(imgData, 'PNG', 0, 0, pdfPageWidth, pdfPageHeight);
  
        y += canvasPage.height;
      }
  
      pdf.save(`${selectedCity}.pdf`);
    } catch (error) {
      console.error("Error generating PDF:", error);
    }
  };
  

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  
  const speakText = (text) => {
    if ('speechSynthesis' in window) {
      const utterance = new SpeechSynthesisUtterance(text);
      utterance.lang = 'en-US'; // Set the language if needed
      window.speechSynthesis.speak(utterance);
    } else {
      console.error('Text-to-Speech not supported in this browser.');
    }
  };

  return (
    <div
      className="relative flex items-center justify-center h-screen bg-cover bg-center"
      style={{
        backgroundImage: `url(${bgImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        opacity: 0.9,
      }}
    >
      <div className="absolute inset-0 bg-black opacity-50"></div>
      <nav className="flex justify-between items-center p-4 bg-transparent absolute top-0 left-0 right-0">
        <button className="text-white" onClick={() => {navigate("/app")
        if ('speechSynthesis' in window) {
      window.speechSynthesis.cancel();
    }
  }}>
          <img
            src="https://img.icons8.com/?size=100&id=40217&format=png&color=FFFFFF"
            alt="Back"
            className="h-6 w-6"
          />
        </button>
        <h1
          className="self-center  whitespace-nowrap text-3xl font-bold text-white cursor-pointer"
          onClick={() => {navigate("/app");if ('speechSynthesis' in window) {
            window.speechSynthesis.cancel();
          }}}
        >
          GemX
        </h1>
        <Avatar
                  width={40}
                  height={40}
                  name={user?.firstName}
                  imageUrl={user?.profile_pic}
                  userId=""
                  rounded
                />
      </nav>
      <div className="flex flex-col md:flex-row items-center justify-center w-full px-8 z-10">
        <div className="hidden md:flex flex-col items-center w-full md:w-1/2 md:mr-20 lg:mr-64 mt-12 md:mt-0 xl:mr-80">
          <img
            src="/robot.png"
            alt="Robot"
            className="h-40 w-40 md:h-64 md:w-60 lg:h-64 lg:w-60 xl:h-80 xl:w-72"
          />
          <p className="text-white text-2xl mt-4">
            TripGenie: Plan your next adventure
          </p>
        </div>
        <div className="flex flex-col items-center w-full md:w-1/2 md:ml-20 space-y-8">
          {!isItineraryGenerated ? (
            <>
              <div className="w-full">
                <label className="text-white mb-2 block text-xl">
                  Where do you want to go?
                </label>
                <div className="relative" ref={dropdownRef}>
                  <input
                    className="w-full p-2 rounded h-8 text-lg dark:bg-slate-900 focus:outline-primary dark:focus-within:bg-black"
                    placeholder="Select a city"
                    value={selectedCity}
                    onChange={(e) => setSelectedCity(e.target.value)}
                    onFocus={() => setIsDropdownOpen(true)}
                  />
                  {isDropdownOpen && (
                    <div className="absolute z-10 w-full bg-white rounded shadow mt-1 dark:bg-slate-900 focus:outline-primary dark:focus-within:bg-black">
                      {cities
                        .filter((city) =>
                          city
                            .toLowerCase()
                            .includes(selectedCity.toLowerCase())
                        )
                        .map((city, index) => (
                          <div
                            key={city}
                            className={`cursor-pointer p-2 ${index === 0 ? "bg-slate-800" : ""
                              } hover:bg-slate-700`}
                            onClick={() => handleCitySelect(city)}
                          >
                            {city}
                          </div>
                        ))}
                    </div>
                  )}
                </div>
              </div>
              <div className="relative w-full">
                <button
                  className="bg-slate-300 dark:bg-slate-900 focus:outline-primary dark:focus-within:bg-black text-white py-2 px-6 rounded flex items-center justify-center w-full"
                  onClick={() => setIsDatepickerOpen(!isDatepickerOpen)}
                >
                  <img
                    src="https://img.icons8.com/ios-filled/50/ffffff/calendar.png"
                    alt="Calendar"
                    className="h-6 w-6 rounded-full mr-2"
                  />
                  Select Dates
                </button>
                {isDatepickerOpen && (
                  <div className="mt-2 w-full bg-white p-2 rounded shadow dark:bg-black focus:outline-primary dark:focus-within:bg-black dateColor">
                    <Datepicker value={value} onChange={handleValueChange} />
                  </div>
                )}
              </div>
              <div className="w-full">
                <h2 className="text-white text-xl mb-2">
                  How many people are going?
                </h2>
                <div className="bg-white rounded-lg py-2 shadow-md dark:bg-slate-900 focus:outline-primary dark:focus-within:bg-black">
                  <div className="flex items-center justify-between px-4">
                    <div className="flex items-center space-x-2">
                      <div className="border text-black p-1 px-4 rounded-lg">
                        <span className="text-lg font-semibold">
                          {numberOfPeople}
                        </span>
                      </div>
                      <span className="text-gray-800 text-lg font-semibold">
                        {numberOfPeople === 1 ? "Person" : "People"}
                      </span>
                    </div>
                    <div className="flex items-center space-x-2">
                      <button
                        className="border text-black px-4 py-1 rounded-lg hover:bg-slate-600 transition duration-300 text-lg"
                        onClick={handleDecrementPeople}
                      >
                        -
                      </button>
                      <button
                        className="border text-black px-4 py-1 rounded-lg hover:bg-slate-600 transition duration-300 text-lg"
                        onClick={handleIncrementPeople}
                      >
                        +
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="w-full">
                <h2 className="text-white text-xl mb-2">Budget Scale</h2>
                <div className="flex items-center justify-between">
                  <span className="text-white">Cheap</span>
                  <input
                    type="range"
                    min="5000"
                    max="100000"
                    step="500"
                    value={budget}
                    onChange={handleBudgetChange}
                    className="w-full mx-4 cursor-pointer"
                  />
                  <span className="text-white">High</span>
                </div>
                <div className="flex justify-between text-white">
                  <span>₹5000</span>
                  <span>₹{budget}</span>
                  <span>₹100000</span>
                </div>
              </div>
              <div onClick={handleGenerateItinerary}>
                <MovingBorderButton className="bg-green-500 text-white py-2 px-6 text-lg rounded-full">
                  {loading ? <LoadingScreen /> : "Generate Itinerary"}
                </MovingBorderButton>
              </div>
            </>
          ) : (
            <>
            
              <div className="w-full md:w-1/1 bg-white dark:bg-slate-950 focus:outline-primary bg-opacity-70 rounded-lg p-8 text-white space-y-4 h-[300px] overflow-y-auto custom-scrollbar">
              <button className="ml-2 flex justify-start items-start">
              {speak ? <PiSpeakerHigh className="text-gray-700 dark:hover:text-gray-400 size-7 hover:text-gray-400 dark:text-slate-200" onClick={()=>{setSpeak(false);speakText(itinerary)}}  />:<PiSpeakerSlash className="text-gray-700 dark:hover:text-gray-400 size-7 hover:text-gray-400 dark:text-slate-200" onClick={()=>{setSpeak(true);if ('speechSynthesis' in window) {
      window.speechSynthesis.cancel();
    }}}/>}                        </button>
                <h2 className="text-2xl font-bold">Your Itinerary</h2>
                <p
                  id="itinerary-content"
                  className="mt-4"
                  dangerouslySetInnerHTML={{ __html: itinerary }}
                ></p>

              </div>
              <div className="flex flex-col items-center w-full space-y-4">
                <div onClick={() => {setIsItineraryGenerated(false);if ('speechSynthesis' in window) {
      window.speechSynthesis.cancel();
    }
    }}>
                  <MovingBorderButton className="mt-6 bg-blue-500 text-white py-2 px-4 rounded-lg text-lg hover:bg-blue-600 transition duration-300">
                    Generate Another Itinerary
                  </MovingBorderButton>
                </div>
                <div onClick={handleDownloadPdf}>
                  <MovingBorderButton className="mt-2 bg-red-500 text-white py-2 px-4 rounded-lg text-lg hover:bg-red-600 transition duration-300">
                    Download PDF
                  </MovingBorderButton>
                </div>
              </div>
                        
                      
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default Itinerary;
